import { Modal as AntdModal } from 'antd'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import classes from './duplicate.module.css'
import cn from 'classnames'
import { Lead } from '@/api/types/crm.types'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'

interface Params {
  originalLeadId: number
  duplicateLead: Lead['last_duplicated_lead']
  onClose: () => void
  onSuccess?: () => void
}

const duplicateModalFn = ({
  originalLeadId,
  duplicateLead,
  onSuccess,
  onClose,
}: Params) => {
  return AntdModal.confirm({
    title: 'Повторная заявка',
    content: `От данного лида была повторная заявка: \nФио - "${
      duplicateLead?.name ?? '(без фио)'
    }", \nТелефон - "${duplicateLead?.phone ?? '(без номера телефона)'}"`,
    icon: null,
    centered: true,
    maskClosable: true,
    className: cn(jclasses.modal, classes.modal),
    okText: 'Ознакомлен',
    cancelText: 'Отменить',
    onOk: () => {
      crmApi
        .updateLead(
          {
            lead_id: originalLeadId,
          },
          {
            is_duplicate: false,
          },
        ).then((res) => {
          if (isError(res)) throw new Error() 
          onSuccess?.()
        })
        .catch((error) => {
          console.error('Ошибка при обновлении лида:', error)
          onClose()
        })
    },
    onCancel: () => onClose(),
  })
}

export default duplicateModalFn
